
// Auth types
export interface AuthApiTokenResponse {
  message: string,
  user: {
    id: string,
    email: string,
    accessToken: string,
    jwt: string,
    domain: string
  }
}

// Storage keys
export const STORAGE_KEYS = {
  API_TOKEN: "mcp_api_token",
  ACCESS_TOKEN: "mcp_access_token",
  USER_ID: "mcp_user_id",
  JWT: "mcp_jwt",
  // DOMAIN: "mcp_domain",
  USER_EMAIL: "mcp_user_email",
  TAB_ACTIVE_ON: "mcp_tab_active_on",
  TAB_ACTIVE_HREF: "mcp_tab_active_href"
} as const;